import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IndicatorState } from '../../consent-requests/consent-requests.component';

@Component({
    selector: 'consent-checklist-indicator',
    templateUrl: './checklist-indicator.component.html',
    styleUrls: ['./checklist-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChecklistIndicatorComponent {
  @Input() indicatorState: IndicatorState;

  public IndicatorState = IndicatorState;
}
